import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { createProduct } from '../../services/Product/productService';
import ErrorModal from '../Modals/ErrorModal';
import SuccessModal from '../Modals/SuccessModal';
import InputField from '../Utils/InputField';
import MeasureUnits from '../Constants/measureUnits';

const CreateProductModal = ({ show, handleClose, refreshProducts, onCreated }) => {
  const { register, handleSubmit, formState: { errors }, reset, control } = useForm();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const onSubmit = async (data) => {
    try {
      const payload = {
        ...data,
        stock: 0,
        active: true
      }

      const created = await createProduct(payload);

      if (onCreated) {
        onCreated({
          id: created.uuid,
          description: created.name,
        });
      } else {
        setSuccessMessage('Produto criado com sucesso!');
        setShowSuccessModal(true);
      }

      reset();
    } catch (error) {
      setErrorMessage(error.message || 'Erro ao criar produto.');
      setShowErrorModal(true);
    }
  };

  const handleCloseErrorModal = () => setShowErrorModal(false);
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    refreshProducts();
    handleClose();
  };

  useEffect(() => {
    if (show) {
      reset();
    }
  }, [show, reset]);

  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Cadastrar Produto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.stopPropagation();
              handleSubmit(onSubmit)(e);
            }}
          >
            <Row>
              <Col md={12}>
                <InputField
                  label="Descrição"
                  name="description"
                  placeholder="Digite a descrição do produto"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Descrição é obrigatória' }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Controller
                  name="unit"
                  control={control}
                  defaultValue=""
                  rules={{ required: 'Unidade é obrigatória' }}
                  render={({ field, fieldState }) => (
                    <Form.Group controlId="unit"className="mb-3">
                      <Form.Label className='mb-1'>Unidade</Form.Label>
                      <Form.Control
                        as="select"
                        {...field}
                        isInvalid={!!fieldState.error}
                      >
                        <option value="">Selecione...</option>
                        {Object.entries(MeasureUnits).map(([key, { value, label }]) => (
                          <option key={key} value={value}>{label}</option>
                        ))}
                      </Form.Control>
                      {fieldState.error && (
                        <Form.Control.Feedback type="invalid">
                          {fieldState.error.message}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={6}>
                <InputField
                  label="Peso por Unidade (kg)"
                  name="unitWeight"
                  placeholder="Digite o peso"
                  type="number"
                  step="0.01"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Peso por unidade é obrigatório', min: { value: 0.01, message: 'Peso deve ser maior que zero' } }}
                />
              </Col>
            </Row>
            <Button variant="primary" className="button-custom w-100 mt-3" type="submit">
              Cadastrar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ErrorModal
        show={showErrorModal}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
      />

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleCloseSuccessModal}
        successMessage={successMessage}
      />
    </>
  );
};

export default CreateProductModal;